import script from "./ApplicationActionButtonCollection.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApplicationActionButtonCollection.vue?vue&type=script&setup=true&lang=ts"

import "./ApplicationActionButtonCollection.vue?vue&type=style&index=0&id=54ddb88a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54ddb88a"]])

export default __exports__